export var NAME = 'account';
export var ACCOUNT_LOADED = "".concat(NAME, "/ACCOUNT_LOADED");
export var RUBRIQ_PLAN_EXPIRATION_UPDATED = "".concat(NAME, "/RUBRIQ_PLAN_EXPIRATION_UPDATED");
export var RUBRIQ_PLAN_LOADED = "".concat(NAME, "/RUBRIQ_PLAN_LOADED");
export var RUBRIQ_PLAN_REQUESTED = "".concat(NAME, "/RUBRIQ_PLAN_REQUESTED");
export var DIGITAL_PURCHASE_CREATED = "".concat(NAME, "/DIGITAL_PURCHASE_CREATED");
export var DIGITAL_PURCHASE_DELETED = "".concat(NAME, "/DIGITAL_PURCHASE_DELETED");
export var DIGITAL_PURCHASES_LOADED = "".concat(NAME, "/DIGITAL_PURCHASES_LOADED");
export var DIGITAL_PURCHASE_UPDATED = "".concat(NAME, "/DIGITAL_PURCHASE_UPDATED");
export var QR_CODE_REQUESTED = "".concat(NAME, "/QR_CODE_REQUESTED");
export var QR_CODE_RETRIEVED = "".concat(NAME, "/QR_CODE_RETRIEVED");
export var UPDATE_REQUESTED = "".concat(NAME, "/UPDATE_REQUESTED");
export var UPDATE_REQUEST_COMPLETED = "".concat(NAME, "/UPDATE_REQUEST_COMPLETED");